var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "w100", style: { overflow: "visible" } },
    [
      _c(
        "w-breadcrumb",
        { attrs: { crumbs: _vm.path } },
        [
          _c("w-input", {
            attrs: { placeholder: _vm.$ct("layoutNameLabel") },
            model: {
              value: _vm.layout.Name,
              callback: function ($$v) {
                _vm.$set(_vm.layout, "Name", $$v)
              },
              expression: "layout.Name",
            },
          }),
          _c("w-spacer"),
          _c(
            "div",
            { staticClass: "v-center" },
            [
              _c(
                "w-button-bar",
                [
                  _c(
                    "w-button",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.zoomOut()
                        },
                      },
                    },
                    [_c("w-fa", { attrs: { icon: "search-minus" } })],
                    1
                  ),
                  _c(
                    "w-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.zoomLevelIndex = 3
                        },
                      },
                    },
                    [_vm._v(" [" + _vm._s(_vm.zoomLevel) + "%] ")]
                  ),
                  _c(
                    "w-button",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.zoomIn()
                        },
                      },
                    },
                    [_c("w-fa", { attrs: { icon: "search-plus" } })],
                    1
                  ),
                  _c("w-button", { on: { click: _vm.save } }, [
                    _vm._v(" " + _vm._s(_vm.$t("common.save")) + " "),
                  ]),
                  _c(
                    "w-dropdown",
                    {
                      attrs: { items: _vm.buttonBarItmes, right: "" },
                      on: {
                        click: function ($event) {
                          return _vm.triggerDropdown($event)
                        },
                      },
                    },
                    [_c("w-fa", { attrs: { icon: "ellipsis-v" } })],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-container",
        { staticClass: "container", attrs: { "no-padding": "" } },
        [
          _c(
            "w-row",
            {
              style: {
                flexGrow: 1,
                position: "relative",
                zIndex: 1,
                flexShrink: 1,
                minHeight: 0,
                overflow: "hidden",
              },
              attrs: { "no-margin": "" },
            },
            [
              _c(
                "app-page-container",
                {
                  attrs: {
                    "zoom-level": _vm.zoomLevel,
                    "page-settings": _vm.layout.Data.PageSettings,
                  },
                },
                [
                  _c("app-page", {
                    attrs: {
                      layout: _vm.reminderLayout,
                      "zoom-level": _vm.zoomLevel,
                      lang: _vm.selectedLang,
                      "show-grid": _vm.showGrid,
                    },
                  }),
                ],
                1
              ),
              _c("app-tab", {
                attrs: { tab: _vm.tab, layout: _vm.reminderLayout },
                on: {
                  "update:tab": function ($event) {
                    _vm.tab = $event
                  },
                },
              }),
              _c("app-tabs", {
                on: {
                  save: function ($event) {
                    return _vm.save()
                  },
                },
                model: {
                  value: _vm.tab,
                  callback: function ($$v) {
                    _vm.tab = $$v
                  },
                  expression: "tab",
                },
              }),
            ],
            1
          ),
          _c(
            "w-modal",
            {
              model: {
                value: _vm.langModalOpen,
                callback: function ($$v) {
                  _vm.langModalOpen = $$v
                },
                expression: "langModalOpen",
              },
            },
            [
              _c(
                "w-card",
                { attrs: { "max-width": "500" } },
                [
                  _c("w-card-title", [
                    _vm._v(_vm._s(_vm.$ct("changeDisplayLanguage"))),
                  ]),
                  _c(
                    "w-card-content",
                    [
                      _c("app-custom-language-select", {
                        model: {
                          value: _vm.selectedLang,
                          callback: function ($$v) {
                            _vm.selectedLang = $$v
                          },
                          expression: "selectedLang",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-card-actions",
                    [
                      _c("w-spacer"),
                      _c("w-button", { on: { click: _vm.closeLangModal } }, [
                        _vm._v(" " + _vm._s(_vm.$t("common.close")) + " "),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.editorSettingsModalOpen
        ? _c(
            "w-modal",
            { attrs: { value: "" } },
            [
              _c("app-editor-settings-edit", {
                on: {
                  close: function ($event) {
                    _vm.editorSettingsModalOpen = false
                  },
                },
                model: {
                  value: _vm.layout.Data.EditorSettings,
                  callback: function ($$v) {
                    _vm.$set(_vm.layout.Data, "EditorSettings", $$v)
                  },
                  expression: "layout.Data.EditorSettings",
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }